import { render, staticRenderFns } from "./mybranddetails.vue?vue&type=template&id=a1693496"
import script from "./mybranddetails.vue?vue&type=script&lang=js"
export * from "./mybranddetails.vue?vue&type=script&lang=js"
import style0 from "./mybranddetails.vue?vue&type=style&index=0&id=a1693496&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports